import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import OfferPageContainer from './OfferPageContainer';
import actions from './OfferPageContainer.actions';
import linkActions from '../OfferPagePromoLinks/OfferPagePromoLinks.actions';
import {
    getLoading,
    isEmpty,
    isPaused
} from './OfferPageContainer.selectors';
import promoCodeActions from '../../../../actions/PromoCodeActions';

const mapStateToPropsSelectors = createStructuredSelector({
    loading: getLoading,
    isEmpty: isEmpty,
    isPaused: isPaused
});

function mapStateToProps(state) {
    return {
        ...mapStateToPropsSelectors(state),
        offer: state.offers.list[0] || {}
    };
}

function mapDispatchToProps() {
    return {
        searchGoalEntries: actions.searchGoalEntries,
        searchLinks: actions.searchLinks,
        searchBanners: actions.searchBanners,
        searchContainers: actions.searchContainers,
        searchLandings: actions.searchLandings,
        saveLinkPresets: linkActions.saveLinkPresets,
        savePromoCode: promoCodeActions.savePromoCode,
        editPromoCode: promoCodeActions.editPromoCode,
        deletePromoCode: promoCodeActions.deletePromoCode
    };
}

function WithRouterProps(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
        <OfferPageContainer
            {...props}
            location={location}
            navigate={navigate}
            params={params}
        />
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouterProps);
